import { useEffect, useState } from "react";
// src/hooks/useLocalStorage.ts
function getItem(key, defaultValue) {
	try {
		const item = window.localStorage.getItem(key);
		return item ? JSON.parse(item) : defaultValue;
	} catch (error) {
		console.warn(`useLocalStorage.getItem(${key}) error getting item`, error, `localStorage value: ${window.localStorage.getItem(key)}`, `removing bad item from localStorage`);
		window.localStorage.removeItem(key);
		return defaultValue;
	}
}
/**
* localStorage.setItem(key, value)
*
* To silently update localStorage, pass opts.silent=true and no event will be emitted to other localStorage listeners.
*
* @param key
* @param value
* @param opts
*/
function setItem(key, value, opts) {
	try {
		if (value === void 0) window.localStorage.removeItem(key);
		else window.localStorage.setItem(key, JSON.stringify(value));
		if (!opts?.silent) window.dispatchEvent(new CustomEvent(`localStorage_${key}`, { detail: { key } }));
	} catch (error) {
		console.warn(`useLocalStorage.setItem(${key}) error setting item`, error, "value: ", value);
	}
}
function useLocalStorage(key, defaultValue) {
	const [storedValue, setStoredValue] = useState(() => {
		return getItem(key, defaultValue instanceof Function ? defaultValue() : defaultValue);
	});
	const setValue = (value) => {
		let valueToStore = value instanceof Function ? value(storedValue) : value;
		if (typeof valueToStore === "undefined") valueToStore = defaultValue instanceof Function ? defaultValue() : defaultValue;
		setItem(key, valueToStore);
		setStoredValue(valueToStore);
	};
	useEffect(() => {
		const handler = (event) => {
			if ((event.key || event.detail?.key) === key) setStoredValue(getItem(key));
		};
		addEventListener(`localStorage_${key}`, handler);
		return () => removeEventListener(`localStorage_${key}`, handler);
	}, []);
	return [storedValue, setValue];
}
useLocalStorage.getItem = getItem;
useLocalStorage.setItem = setItem;
export { useLocalStorage };

//# sourceMappingURL=useLocalStorage.js.map